import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Leaf, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { BRAND } from "@/lib/appApi";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => { if (!loading && user) navigate("/admin", { replace: true }); }, [user, loading, navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="relative hidden lg:block">
        <img src={BRAND.hero} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-dlh-greenDark/80" />
        <div className="relative z-10 h-full flex flex-col justify-center p-12 text-white">
          <Leaf className="h-12 w-12 text-dlh-greenLight mb-6" />
          <h1 className="font-serif text-4xl font-extrabold leading-tight">PAPA BERSERI NEWS</h1>
          <p className="mt-3 text-dlh-greenLight text-lg">Portal Informasi Lingkungan Hidup Kabupaten Mimika</p>
          <p className="mt-6 text-white/70 max-w-md">Dashboard pengelola untuk menulis, memeriksa, menyetujui, dan menerbitkan konten. Akses hanya untuk pengelola yang ditetapkan.</p>
        </div>
      </div>

      <div className="flex flex-col items-center justify-center p-8 bg-white">
        <div className="w-full max-w-sm">
          <img src={BRAND.logo} alt="Logo" className="h-16 w-16 rounded-full mx-auto mb-6 ring-2 ring-dlh-greenLight/40" />
          <h2 className="font-serif text-2xl font-extrabold text-dlh-green text-center">Login Pengelola</h2>
          <p className="text-center text-gray-500 text-sm mt-2 mb-8">Masuk menggunakan akun Google yang telah ditetapkan pengelola.</p>

          <button onClick={login} data-testid="google-login-btn"
            className="w-full flex items-center justify-center gap-3 border border-gray-300 rounded-full py-3 font-semibold text-gray-700 hover:bg-gray-50 hover:shadow transition-all focus:ring-2 focus:ring-dlh-orange">
            <svg className="h-5 w-5" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/><path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.3 9.14 5.38 12 5.38z"/></svg>
            Masuk dengan Google
          </button>

          <p className="text-xs text-gray-400 text-center mt-6">Belum memiliki akses? Hubungi Super Admin portal untuk penetapan peran.</p>
          <Link to="/" className="mt-8 flex items-center justify-center gap-2 text-sm text-dlh-greenMid hover:text-dlh-orange"><ArrowLeft className="h-4 w-4" /> Kembali ke Portal</Link>
        </div>
      </div>
    </div>
  );
}
